import React, { useContext } from 'react';
import Context from '../../Context';
import { shuffleVideos } from '../../utils';
import RaisedButton from './RaisedButton';

const styles = {
  fontSize: '2rem',
  padding: '1rem',
  margin: '1rem',
};

export default function Shuffle() {
  const videoCount = 10;
  const { setClips } = useContext(Context);
  const nextVidIds = shuffleVideos(videoCount);

  return (
    <RaisedButton
      className="shuffle-button"
      onClick={() => setClips(nextVidIds)}
      color="red"
      hover="red"
      background="yellow"
      style={styles}
    >
      Shuffle
    </RaisedButton>

  );
}
